import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUser } from "store/selector"; // Replace with your selector for user state
import { menu } from "constant/menu";
import { getItem } from "utils/local-storage";

const ProtectedRoute = ({ children }) => {
  const { token, profileStatus } = useSelector(getUser); // Check if the user is authenticated
  const location = useLocation();
  const isCommonRoute = menu.some(
    (item) => item.link === location.pathname && item.isCommonRoute
  );

  const tokenFromStorage = getItem("the_main_app");

  if (!token && !tokenFromStorage && !isCommonRoute) {
    // Redirect to login if not authenticated (no redux token and no localStorage token)
    // Preserve attempted location so we can return after successful login
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Block deactivated users from visiting any non-common route
  if (profileStatus === "deactivated" && !isCommonRoute) {
    return <Navigate to="/contact-us" replace />;
  }

  // Render the protected component if authenticated
  return children;
};

export default ProtectedRoute;
